import { render, staticRenderFns } from "./TermsAndConditionsMobileView.vue?vue&type=template&id=3f8966de&scoped=true&"
import script from "./TermsAndConditionsMobileView.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8966de",
  null
  
)

export default component.exports